var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPencilWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5L6.5 16L6.43656 15.7463C6.16785 14.6714 5.3286 13.8321 4.25374 13.5634L4 13.5L12.5 5L12.7537 5.06344C13.8286 5.33215 14.6679 6.1714 14.9366 7.24626L15 7.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.5L4.25374 13.5634C5.3286 13.8321 6.16785 14.6714 6.43656 15.7463L6.5 16L2 18L4 13.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 5.75L15.5 7L15.4366 6.74626C15.1679 5.6714 14.3286 4.83215 13.2537 4.56344L13 4.5L14.25 3.25C14.9404 2.55964 16.0596 2.55964 16.75 3.25C17.4404 3.94036 17.4404 5.05964 16.75 5.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencilWhite);
export default __webpack_public_path__ + "static/media/icon-pencil-white.8e68ab81ac085082847e1955a6146fee.svg";
export { ForwardRef as ReactComponent };